import React, { useContext, useEffect, useState, useCallback } from "react";
import GroundTable from "../component/GroundTable";
import { AuthContext } from "../auth/ContextAuthentication";
import useAxiosConfig from "../config/AxiosConfig";
import AddGroundModal from "../component/AddGroundModal"; // Import the modal component
import { ErrorLoadingContext } from "../auth/ErrorLoadingContext";
import { Button, Pagination } from "@mui/material";
const GroundProfile = () => {
  const axiosInstance = useAxiosConfig();
  const headerData = [
    "Name",
    // "No of Players",
    // "No of Fields",
    // "Dimensions",
    // "City",
    "Ground Wallet",
    "Manager Name",
    "Phone Number",
    // "Created At",
    "Status",
  ];
  // test
  // test

  const { setGroundData } = useContext(AuthContext);
  // const { setGroundPagination } = useContext(AuthContext);
  const [managersName, setManagersName] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [totalPages, setTotalPages] = useState(false);
  const [sportId, setSportId] = useState("");
  // const { setSports } = useContext(AuthContext);

  const [page, setPage] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [onSearchChange, setOnSearchChange] = useState("");

  const [newGroundData, setNewGroundData] = useState({
    name: "",
    owner: "",
    durationDay: 0,
    durationNight: 0,
    pricePerBookingDay: 0,
    pricePerBookingNight: 0,
    perPlayer: 0,
    noOfPlayers: 0,
    numberOfFields: 0,
    dimensions: "",
    floodLights: false,
    restRooms: false,
    parkingArea: false,
    securityCameras: false,
    seatingArea: false,
    footballs: false,
    bibs: false,
    address: "",
    location: "",
    city: "",
    images: [],
  });

  const { setLoading, setError } = useContext(ErrorLoadingContext);
  // useEffect(() => {
  //   console.log("sport ID is ", sportId);
  // }, [sportId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOnSearchChange(searchValue);
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchValue]);

  useEffect(() => {
    console.log("The selected startDate is this one ", startDate);
    console.log("The selected endDate is this one ", endDate);
  }, [startDate, endDate]);

  useEffect(() => {
    console.log("The selected startDate is this one ", searchValue);
  }, [searchValue]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleShowModal = () => {
    setShowModal(true);
  };

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewGroundData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSaveGround = async () => {
    try {
      const response = await axiosInstance.post(
        "/api/admin/saveGround",
        newGroundData
      );
      if (response.status === 201) {
        fetchGroundData();
      }
    } catch (error) {
      console.error("Error saving ground data:", error);
    }
  };

  const fetchGroundData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(
        `/api/admin/get-all-grounds?page=${page}&groundName=${onSearchChange}&sportsId=${sportId}&startDate=${startDate}&endDate=${endDate}`
      );
      if (response.status === 200) {
        setGroundData(response.data.grounds);
        setTotalPages(response.data.totalPages);
        setLoading(false);
      }
    } catch (error) {
      setError("Error fetching data");
      setLoading(false);
    }
  }, [axiosInstance, endDate, onSearchChange, page, setError, setGroundData, setLoading, sportId, startDate]);

  useEffect(() => {
    fetchGroundData();
  }, [fetchGroundData]);

  const handleSelectedSports = (id) => {
    setSportId(id);
  };
  const handleDateValues = (label, value) => {
    if (label === "startDate") {
      setStartDate(value);
    } else {
      setEndDate(value);
    }
  };

  const handleSearchValues = (value) => {
    console.log(
      "THis call is not recorded and youll be contacted by my expert",
      value
    );
    setSearchValue(value);
  };

  return (
    <div className="flex flex-col">
      <h2 className="text-xl font-bold mb-4">Grounds</h2>
      <div className="mb-2">
        <Button
          variant="contained"
          sx={{ backgroundColor: "#0C7240", ":hover": { bgcolor: "#0C7240" } }}
          onClick={handleShowModal}
        >
          Add Ground
        </Button>
      </div>

      <div>
        <GroundTable
          headerData={headerData}
          totalPages={totalPages}
          handleSelectedSports={handleSelectedSports}
          handleDateValues={handleDateValues}
          handleSearchValues={handleSearchValues}
        />
      </div>

      {/* <button onClick={handleShowModal}>
        <FaPlus className="cursor-pointer text-3xl text-green-800 absolute top-16 right-100 z-1  " />
      </button> */}

      <div className="flex justify-center mt-1">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
        />
      </div>

      <AddGroundModal
        showModal={showModal}
        handleClose={handleCloseModal}
        handleSave={handleSaveGround}
        newGroundData={newGroundData}
        handleInputChange={handleInputChange}
        setNewGroundData={setNewGroundData}
        managersName={managersName}
        setManagersName={setManagersName}
        totalPages={totalPages}
      />
    </div>
  );
};

export default GroundProfile;
